import styles from "../../../styles/shared/create-bot/CreateBotSettings.module.css";
import {
  FaBalanceScale,
  FaBitcoin,
  FaSmile,
} from "react-icons/fa";
import { Tooltip } from "antd";
import { IoInformationCircleOutline } from "react-icons/io5";
import { TbReportSearch } from "react-icons/tb";

function CryptoAllocationSettings({ cryptoAllocation, changeConfig }) {

  return (
    <>
      <div className={styles.stepTitle}>
        <h6>
          <TbReportSearch color="#0c4cfc" size={18} /> Choose your preferred crypto allocation strategy
        </h6>
      </div>
      <ul className={styles.allocationOptions}>
        <li
        // className={`${styles.allocationItem} ${
        //   cryptoAllocation === "balanced" ? styles.active : ""
        // }`}
        >
          <Tooltip
            title="50% Bitcoin, 30% Ethereum, 20% Other Altcoins"
            color="blue"
            className={`${styles.allocationItem} ${cryptoAllocation === "balanced" ? styles.active : ""}`}
            onClick={() =>
              changeConfig("crypto_allocation_strategy", "balanced")
            }
          >
            <FaBalanceScale />
            Balanced
            <IoInformationCircleOutline color="#0c4cfc" size={18} />
          </Tooltip>
        </li>
        <li
        // className={`${styles.allocationItem} ${
        //   cryptoAllocation === "bitcoin_dominant" ? styles.active : ""
        // }`}
        >
          <Tooltip
            title="70% Bitcoin, 20% Ethereum, 10% Other Altcoins"
            color="blue"
            className={`${styles.allocationItem} ${cryptoAllocation === "bitcoin_dominant" ? styles.active : ""}`}
            onClick={() =>
              changeConfig("crypto_allocation_strategy", "bitcoin_dominant")
            }
          >
            <FaBitcoin />
            Bitcoin Dominant
            <IoInformationCircleOutline color="#0c4cfc" size={18} />
          </Tooltip>
        </li>
        <li
        // className={`${styles.allocationItem} ${
        //   cryptoAllocation === "altcoin_enthusiast" ? styles.active : ""
        // }`}
        >
          <Tooltip
            title="30% Bitcoin, 40% Ethereum, 30% Other Altcoins"
            color="blue"
            className={`${styles.allocationItem} ${cryptoAllocation === "altcoin_enthusiast" ? styles.active : ""}`}
            onClick={() =>
              changeConfig("crypto_allocation_strategy", "altcoin_enthusiast")
            }
          >
            <FaSmile />
            Altcoin Enthusiast
            <IoInformationCircleOutline color="#0c4cfc" size={18} />
          </Tooltip>
        </li>
      </ul>
    </>
  );
}

export default CryptoAllocationSettings;
